import inst from '@/backend/axios-instances'

const instance = inst.baseInstance
const resource = '/permissions'

export default {
  get() {
    return instance.get(`${resource}/all`);
  },
  getPolicies(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  }
}